import { Injectable } from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { Observable } from 'rxjs';

import { AlertComponent } from '@app/shared/components/alert/alert.component';
import { ConfirmComponent } from '@app/shared/components/confirm/confirm.component';
import { AppUtil } from '@app/utils/app.util';

@Injectable()
export class ModalService {

  constructor(
    private ngbModal: NgbModal
  ) { }

  alert(severidade?: string, resumo?: string, detalhe?: string): Observable<boolean> {

    const inputModal = this.ngbModal.open(
      AlertComponent, {
      ariaLabelledBy: 'ssModalAlert',
      windowClass: AppUtil.severidade(severidade).cor
    });
    inputModal.componentInstance.severidade = severidade;
    inputModal.componentInstance.resumo = resumo;
    inputModal.componentInstance.detalhe = detalhe;

    return inputModal.componentInstance.retorno;

  }

  confirm(severidade?: string, resumo?: string, detalhe?: string): Observable<boolean> {

    const inputModal = this.ngbModal.open(
      ConfirmComponent, {
      ariaLabelledBy: 'ssModalConfirm',
      windowClass: AppUtil.severidade(severidade).cor
    });
    inputModal.componentInstance.severidade = severidade;
    inputModal.componentInstance.resumo = resumo;
    inputModal.componentInstance.detalhe = detalhe;

    return inputModal.componentInstance.retorno;

  }

}
